// EchoFloat media-plane control messages: bodies of UDP packets with type=Control.
// Always transport-AEAD sealed (docs/protocol.md §2). Source of truth: §1, §5, §6.

// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file echo/media/v1/media.proto (package echo.media.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file echo/media/v1/media.proto.
 */
export const file_echo_media_v1_media: GenFile = /*@__PURE__*/
  fileDesc("ChllY2hvL21lZGlhL3YxL21lZGlhLnByb3RvEg1lY2hvLm1lZGlhLnYxItsECg5Db250cm9sTWVzc2FnZRIyCgxjbGllbnRfaGVsbG8YASABKAsyGi5lY2hvLm1lZGlhLnYxLkNsaWVudEhlbGxvSAASLAoJaGVsbG9fYWNrGAIgASgLMhcuZWNoby5tZWRpYS52MS5IZWxsb0Fja0gAEicKBnJlc3VtZRgDIAEoCzIVLmVjaG8ubWVkaWEudjEuUmVzdW1lSAASLgoKcmVzdW1lX2FjaxgEIAEoCzIYLmVjaG8ubWVkaWEudjEuUmVzdW1lQWNrSAASOAoPcmVjZWl2ZXJfcmVwb3J0GAUgASgLMh0uZWNoby5tZWRpYS52MS5SZWNlaXZlclJlcG9ydEgAEjgKD3NlbmRlcl9mZWVkYmFjaxgGIAEoCzIdLmVjaG8ubWVkaWEudjEuU2VuZGVyRmVlZGJhY2tIABIwCgtzcGVha2VyX3NldBgHIAEoCzIZLmVjaG8ubWVkaWEudjEuU3BlYWtlclNldEgAEikKB2dvb2RieWUYCCABKAsyFi5lY2hvLm1lZGlhLnYxLkdvb2RieWVIABI6ChBzdWJzY3JpYmVfc3RyZWFtGAkgASgLMh4uZWNoby5tZWRpYS52MS5TdWJzY3JpYmVTdHJlYW1IABI+ChJ1bnN1YnNjcmliZV9zdHJlYW0YCiABKAsyIC5lY2hvLm1lZGlhLnYxLlVuc3Vic2NyaWJlU3RyZWFtSAASOgoQcmVxdWVzdF9rZXlmcmFtZRgLIAEoCzIeLmVjaG8ubWVkaWEudjEuUmVxdWVzdEtleWZyYW1lSABCBQoDbXNnIjcKC0NsaWVudEhlbGxvEhcKD2hhbmRzaGFrZV90b2tlbhgBIAEoDBIPCgdwYWRkaW5nGAIgASgMIjgKCEhlbGxvQWNrEhUKDWV4dGVybmFsX2FkZHIYASABKAkSFQoNcmVzdW1lX3NlY3JldBgCIAEoDCIfCgZSZXN1bWUSFQoNcmVzdW1lX3NlY3JldBgBIAEoDCIiCglSZXN1bWVBY2sSFQoNZXh0ZXJuYWxfYWRkchgBIAEoCSKBAQoTUmVjZWl2ZXJSZXBvcnRFbnRyeRIRCglzZW5kZXJfaWQYASABKA0SFQoNZnJhY3Rpb25fbG9zdBgCIAEoDRIRCglqaXR0ZXJfbXMYAyABKA0SFwoPZXh0X2hpZ2hlc3Rfc2VxGAQgASgNEhQKDHBheWxvYWRfdHlwZRgFIAEoDSJFCg5SZWNlaXZlclJlcG9ydBIzCgdlbnRyaWVzGAEgAygLMiIuZWNoby5tZWRpYS52MS5SZWNlaXZlclJlcG9ydEVudHJ5ImAKDlNlbmRlckZlZWRiYWNrEhUKDWZyYWN0aW9uX2xvc3QYASABKA0SEQoJaml0dGVyX21zGAIgASgNEg4KBnJ0dF9tcxgDIAEoDRIUCgxwYXlsb2FkX3R5cGUYBCABKA0iIAoKU3BlYWtlclNldBISCgpzZW5kZXJfaWRzGAEgAygNIgkKB0dvb2RieWUiOgoPU3Vic2NyaWJlU3RyZWFtEhEKCXNlbmRlcl9pZBgBIAEoDRIUCgxwYXlsb2FkX3R5cGUYAiABKA0iPAoRVW5zdWJzY3JpYmVTdHJlYW0SEQoJc2VuZGVyX2lkGAEgASgNEhQKDHBheWxvYWRfdHlwZRgCIAEoDSIkCg9SZXF1ZXN0S2V5ZnJhbWUSEQoJc2VuZGVyX2lkGAEgASgNYgZwcm90bzM");

/**
 * @generated from message echo.media.v1.ControlMessage
 */
export type ControlMessage = Message<"echo.media.v1.ControlMessage"> & {
  /**
   * @generated from oneof echo.media.v1.ControlMessage.msg
   */
  msg: {
    /**
     * @generated from field: echo.media.v1.ClientHello client_hello = 1;
     */
    value: ClientHello;
    case: "clientHello";
  } | {
    /**
     * @generated from field: echo.media.v1.HelloAck hello_ack = 2;
     */
    value: HelloAck;
    case: "helloAck";
  } | {
    /**
     * @generated from field: echo.media.v1.Resume resume = 3;
     */
    value: Resume;
    case: "resume";
  } | {
    /**
     * @generated from field: echo.media.v1.ResumeAck resume_ack = 4;
     */
    value: ResumeAck;
    case: "resumeAck";
  } | {
    /**
     * @generated from field: echo.media.v1.ReceiverReport receiver_report = 5;
     */
    value: ReceiverReport;
    case: "receiverReport";
  } | {
    /**
     * @generated from field: echo.media.v1.SenderFeedback sender_feedback = 6;
     */
    value: SenderFeedback;
    case: "senderFeedback";
  } | {
    /**
     * @generated from field: echo.media.v1.SpeakerSet speaker_set = 7;
     */
    value: SpeakerSet;
    case: "speakerSet";
  } | {
    /**
     * @generated from field: echo.media.v1.Goodbye goodbye = 8;
     */
    value: Goodbye;
    case: "goodbye";
  } | {
    /**
     * @generated from field: echo.media.v1.SubscribeStream subscribe_stream = 9;
     */
    value: SubscribeStream;
    case: "subscribeStream";
  } | {
    /**
     * @generated from field: echo.media.v1.UnsubscribeStream unsubscribe_stream = 10;
     */
    value: UnsubscribeStream;
    case: "unsubscribeStream";
  } | {
    /**
     * @generated from field: echo.media.v1.RequestKeyframe request_keyframe = 11;
     */
    value: RequestKeyframe;
    case: "requestKeyframe";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message echo.media.v1.ControlMessage.
 * Use `create(ControlMessageSchema)` to create a new message.
 */
export const ControlMessageSchema: GenMessage<ControlMessage> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 0);

/**
 * C -> SFU, retried every 250ms up to 5s. Sealed with key_c2s; SFU identifies
 * the pending session by header.sender_id (few candidates -> AEAD-verify each).
 *
 * @generated from message echo.media.v1.ClientHello
 */
export type ClientHello = Message<"echo.media.v1.ClientHello"> & {
  /**
   * 32B from JoinAccept
   *
   * @generated from field: bytes handshake_token = 1;
   */
  handshakeToken: Uint8Array;

  /**
   * anti-amplification: response must not exceed request size before auth,
   * so the client pads the hello (>= 96 zero bytes)
   *
   * @generated from field: bytes padding = 2;
   */
  padding: Uint8Array;
};

/**
 * Describes the message echo.media.v1.ClientHello.
 * Use `create(ClientHelloSchema)` to create a new message.
 */
export const ClientHelloSchema: GenMessage<ClientHello> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 1);

/**
 * SFU -> C. src of the UDP packet = client's external addr (IP discovery).
 *
 * @generated from message echo.media.v1.HelloAck
 */
export type HelloAck = Message<"echo.media.v1.HelloAck"> & {
  /**
   * "ip:port" as seen by the SFU
   *
   * @generated from field: string external_addr = 1;
   */
  externalAddr: string;

  /**
   * 32B, lives for the whole SFU session
   *
   * @generated from field: bytes resume_secret = 2;
   */
  resumeSecret: Uint8Array;
};

/**
 * Describes the message echo.media.v1.HelloAck.
 * Use `create(HelloAckSchema)` to create a new message.
 */
export const HelloAckSchema: GenMessage<HelloAck> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 2);

/**
 * C -> SFU from a new src addr after network change; silent resume, no GW.
 *
 * @generated from message echo.media.v1.Resume
 */
export type Resume = Message<"echo.media.v1.Resume"> & {
  /**
   * @generated from field: bytes resume_secret = 1;
   */
  resumeSecret: Uint8Array;
};

/**
 * Describes the message echo.media.v1.Resume.
 * Use `create(ResumeSchema)` to create a new message.
 */
export const ResumeSchema: GenMessage<Resume> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 3);

/**
 * @generated from message echo.media.v1.ResumeAck
 */
export type ResumeAck = Message<"echo.media.v1.ResumeAck"> & {
  /**
   * @generated from field: string external_addr = 1;
   */
  externalAddr: string;
};

/**
 * Describes the message echo.media.v1.ResumeAck.
 * Use `create(ResumeAckSchema)` to create a new message.
 */
export const ResumeAckSchema: GenMessage<ResumeAck> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 4);

/**
 * C -> SFU every 1s: reception quality per forwarded stream (docs/protocol.md §5).
 *
 * @generated from message echo.media.v1.ReceiverReportEntry
 */
export type ReceiverReportEntry = Message<"echo.media.v1.ReceiverReportEntry"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * 0..255, like RTCP
   *
   * @generated from field: uint32 fraction_lost = 2;
   */
  fractionLost: number;

  /**
   * @generated from field: uint32 jitter_ms = 3;
   */
  jitterMs: number;

  /**
   * extended (wrap-corrected) highest seq seen
   *
   * @generated from field: uint32 ext_highest_seq = 4;
   */
  extHighestSeq: number;

  /**
   * Which of that sender's streams this is about (screenshare-plan.md D76):
   * 0 = Opus/voice, 1 = H.264/video, 2 = Opus/application audio. Absent means
   * 0, so an older client's reports still say "voice" and nothing has to guess.
   *
   * Without it the whole point of D76 is unreachable: a stream has its own seq
   * and its own losses, and one report per sender would fold a screencast's
   * packet loss into the voice adaptation state machine — exactly the failure
   * the split was made to avoid.
   *
   * @generated from field: uint32 payload_type = 5;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.ReceiverReportEntry.
 * Use `create(ReceiverReportEntrySchema)` to create a new message.
 */
export const ReceiverReportEntrySchema: GenMessage<ReceiverReportEntry> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 5);

/**
 * @generated from message echo.media.v1.ReceiverReport
 */
export type ReceiverReport = Message<"echo.media.v1.ReceiverReport"> & {
  /**
   * @generated from field: repeated echo.media.v1.ReceiverReportEntry entries = 1;
   */
  entries: ReceiverReportEntry[];
};

/**
 * Describes the message echo.media.v1.ReceiverReport.
 * Use `create(ReceiverReportSchema)` to create a new message.
 */
export const ReceiverReportSchema: GenMessage<ReceiverReport> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 6);

/**
 * SFU -> sender every 1s: aggregated view of one of the sender's own streams,
 * drives the good/degraded/bad adaptation state machine (one instance of it per
 * stream — the voice ladder and the video ladder in §5 are different tables).
 *
 * @generated from message echo.media.v1.SenderFeedback
 */
export type SenderFeedback = Message<"echo.media.v1.SenderFeedback"> & {
  /**
   * 0..255, worst across receivers
   *
   * @generated from field: uint32 fraction_lost = 1;
   */
  fractionLost: number;

  /**
   * max across receivers
   *
   * @generated from field: uint32 jitter_ms = 2;
   */
  jitterMs: number;

  /**
   * from ping/pong
   *
   * @generated from field: uint32 rtt_ms = 3;
   */
  rttMs: number;

  /**
   * as in ReceiverReportEntry; absent = 0 = voice
   *
   * @generated from field: uint32 payload_type = 4;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.SenderFeedback.
 * Use `create(SenderFeedbackSchema)` to create a new message.
 */
export const SenderFeedbackSchema: GenMessage<SenderFeedback> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 7);

/**
 * SFU -> all clients on top-3 set change (docs/protocol.md §6).
 *
 * @generated from message echo.media.v1.SpeakerSet
 */
export type SpeakerSet = Message<"echo.media.v1.SpeakerSet"> & {
  /**
   * @generated from field: repeated uint32 sender_ids = 1;
   */
  senderIds: number[];
};

/**
 * Describes the message echo.media.v1.SpeakerSet.
 * Use `create(SpeakerSetSchema)` to create a new message.
 */
export const SpeakerSetSchema: GenMessage<SpeakerSet> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 8);

/**
 * either side: graceful leave
 *
 * @generated from message echo.media.v1.Goodbye
 */
export type Goodbye = Message<"echo.media.v1.Goodbye"> & {
};

/**
 * Describes the message echo.media.v1.Goodbye.
 * Use `create(GoodbyeSchema)` to create a new message.
 */
export const GoodbyeSchema: GenMessage<Goodbye> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 9);

/**
 * C -> SFU: start forwarding me this stream.
 *
 * @generated from message echo.media.v1.SubscribeStream
 */
export type SubscribeStream = Message<"echo.media.v1.SubscribeStream"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * 1 = video, 2 = application audio
   *
   * @generated from field: uint32 payload_type = 2;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.SubscribeStream.
 * Use `create(SubscribeStreamSchema)` to create a new message.
 */
export const SubscribeStreamSchema: GenMessage<SubscribeStream> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 10);

/**
 * C -> SFU: stop. Sent on leaving the stream screen (D106) — an open
 * subscription nobody is looking at costs the viewer 2 Mbit/s of downlink and
 * the SFU the same in egress.
 *
 * @generated from message echo.media.v1.UnsubscribeStream
 */
export type UnsubscribeStream = Message<"echo.media.v1.UnsubscribeStream"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;

  /**
   * @generated from field: uint32 payload_type = 2;
   */
  payloadType: number;
};

/**
 * Describes the message echo.media.v1.UnsubscribeStream.
 * Use `create(UnsubscribeStreamSchema)` to create a new message.
 */
export const UnsubscribeStreamSchema: GenMessage<UnsubscribeStream> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 11);

/**
 * C -> SFU: I could not reassemble a frame, send me a reference one.
 *
 * The SFU throttles these to one per KEYFRAME_MIN_INTERVAL_MS per stream — not
 * per requester — and forwards a single one to the streamer (D85). Ten viewers
 * joining at once must not order ten I-frames back to back.
 *
 * @generated from message echo.media.v1.RequestKeyframe
 */
export type RequestKeyframe = Message<"echo.media.v1.RequestKeyframe"> & {
  /**
   * @generated from field: uint32 sender_id = 1;
   */
  senderId: number;
};

/**
 * Describes the message echo.media.v1.RequestKeyframe.
 * Use `create(RequestKeyframeSchema)` to create a new message.
 */
export const RequestKeyframeSchema: GenMessage<RequestKeyframe> = /*@__PURE__*/
  messageDesc(file_echo_media_v1_media, 12);

